<template>
<div id="hotel-description">
    <v-card flat class="pa-sm-3">
        <v-form v-model="valid" ref="hotel_details">
            <div class="py-3">
                <v-text-field class="pa-0 my-1" :label="$t('hotel.detail.name')" v-model="item.name" :rules="rules.name" required @input="is_dirty=true" />
                <v-select class="pa-0 my-1" :label="$t('hotel.detail.unit_type')" v-model="item.unit_type" :items="config.unit_type_slug" required :rules="rules.type" :menu-props="{transition:'scale-transition', 'offset-y': ''}">
                    <template v-slot:selection="data">
                        <span class="text-capitalize">
                            {{$t('hotel.detail.unit_types.' + data.item)}}
                        </span>
                    </template>
                    <template v-slot:item="data">
                        <span class="text-capitalize">
                            {{$t('hotel.detail.unit_types.' + data.item)}}
                        </span>
                    </template>
                </v-select>
                <v-checkbox class="pa-0 my-1" v-model="chain" :label="$t('hotel.detail.chain')" color="primary"></v-checkbox>
                <v-text-field v-if="chain" class="pa-0 my-1" :label="$t('hotel.detail.chain_name')" v-model="item.static.defaults.chain" :required="chain" :rules="rule_chain" />
                <v-checkbox class="ma-0 pa-0" v-model="clasification" :label="$t('hotel.detail.classification')" color="primary" hide-details></v-checkbox>
                <v-row class="py-1" v-if="clasification">
                    <v-col cols="12" class="py-0" md="4">
                        <v-rating v-model="item.static.defaults.stars"></v-rating>
                    </v-col>
                    <v-col cols="12" class="py-0" md="8" :class="{'pt-2': $vuetify.breakpoint.smAndDown}">
                        <v-text-field class="pa-0 my-1" :label="$t('hotel.detail.nr_classification')" v-model="item.static.defaults.certificate" :required="clasification" :rules="rule_clasification" />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" class="py-0" md="2">
                        <v-text-field :label="$t('hotel.detail.capacity')" v-model="item.static.defaults.capacity" />
                    </v-col>
                    <v-col cols="12" class="py-0" md="5">
                        <v-select :items="context" v-model="item.context" item-text="text" item-value="value" :label="$t('hotel.detail.context')" required :rules="rules.context" />
                    </v-col>
                    <v-col cols="12" class="py-0" md="5">
                        <v-select :items="status_hotel" v-model="item.status" item-text="text" item-value="value" :label="$t('hotel.detail.status.label')" />
                    </v-col>
                </v-row>
            </div>

            <v-row :class="{'d-none':!admin}">
                <v-col cols="12" sm="3" class="py-0">
                    <suglify v-if="item.name" :slugify="(!is_dirty)?item.slug:item.name" :slug.sync="item.slug" :extras="{'*' : ''}">
                        <v-text-field v-model="item.slug" :label="$t('hotel.detail.slug')" />
                    </suglify>
                </v-col>
                <v-col cols="12" sm="3" class="py-0" v-if="admin">
                    <v-text-field v-model="item.net_commission" :label="$t('hotel.detail.net_commission')" />
                </v-col>
                <v-col cols="12" sm="3" class="py-0" v-if="admin">
                    <v-text-field v-model="item.gross_commission" :label="$t('hotel.detail.gross_commission')" />
                </v-col>
                <v-col cols="12" sm="3" class="py-0" v-if="admin">
                    <v-select :items="boolean_values" v-model="item.static.for_testing" item-text="text" item-value="value" :label="$t('hotel.detail.test')" />
                </v-col>
            </v-row>

            <div class="important font-weight-bold">{{ $t('hotel.detail.title_hotel_description') }}</div>

            <div class="regular red--text pt-2 pl-2" v-if="!status">
                {{ $t('hotel.detail.message_error') }}
            </div>
            <v-row>
                <v-col cols="12" class="py-0">
                    <v-tabs v-model="description" slider-color="primary" right class="px-2">
                        <!-- hotel description -->
                        <v-tab ripple>
                            <v-avatar size="24" class="mr-2" tile>
                                <img :src="ro" alt="alt">
                            </v-avatar>Romana
                        </v-tab>
                        <v-tab-item>
                            <v-textarea :class="{'description-warning':(warning_message_ro.length >0)}" label="Descriere unitate" auto-grow v-model="item.description.ro" filled :required="active.validate" :messages="warning_message_ro" :rules="rules.description" />
                        </v-tab-item>
                        <v-tab ripple>
                            <v-avatar size="24" class="mr-2" tile>
                                <img :src="gb" alt="alt">
                            </v-avatar>English
                        </v-tab>
                        <v-tab-item>
                            <v-textarea label="Description" auto-grow v-model="item.description.en" filled required />
                        </v-tab-item>
                    </v-tabs>
                </v-col>
            </v-row>
        </v-form>
    </v-card>
</div>
</template>

<script>
import {
    mapActions
} from 'vuex';
import ro_flag from '../../../../assets/ro.svg';
import gb_flag from '../../../../assets/gb.svg';
import storage from '../../../../storage';

export default {
    props: {
        item: Object,
        config: Object,
        active: Object
    },
    name: `hotel-details`,
    components: {},
    data() {
        return {
            is_dirty: false,
            valid: false,
            admin: false,
            ro: ro_flag,
            gb: gb_flag,
            tab_hotel: null,
            description: null,
            hover: false,
            // input input items,
            languages: [],
            stars: [],

            chain: false,
            clasification: (this.item.static.defaults.stars > 0 && this.item.static.defaults.certificate_status == "active"),

            context: [
                {
                    text: "iMemento",
                    value: "imemento"
                }, {
                    text: "YieldPlanet",
                    value: "yieldplanet"
                }, {
                    text: "PynBooking",
                    value: "pynbooking"
                }, {
                    text: "WebHotelier",
                    value: "webhotelier"
                }, {
                    text: "FiveStar",
                    value: "fivestar"
                }
            ],


        };
    },

    watch: {
        item: {
            handler() {
                this.item.static.defaults.stars = Number(this.item.static.defaults.stars);
                if(this.item.static.defaults.stars > 0 && this.item.static.defaults.certificate_status == "active") {
                    this.clasification = true
                } else {
                    this.clasification = false
                }
                this.checkChain();
            }
        },
        valid: {
            handler() {
                this.$emit('validate', [0, this.valid]);
            }
        },
        clasification: {
            handler() {
                if(this.clasification) {
                    this.item.static.defaults.certificate_status = "active"
                } else {
                    this.item.static.defaults.certificate_status = "not-certified"
                }
            }
        }

    },

    async mounted() {
        this.item.static.defaults.stars = Number(this.item.static.defaults.stars);
        this.checkChain();
        let roles = await storage.getRoles();
        this.admin = (roles.ssr_console.includes('admin'));
    },

    computed: {

        rule_clasification() {
            if(this.clasification) {
                return this.rules.clasification
            } else {
                return []
            }
        },
        rule_chain() {
            if(this.chain) {
                return this.rules.chain
            } else {
                return []
            }
        },
        status() {
            if(this.active.validate == false) {
                this.$nextTick(() => {
                    this.$refs.hotel_details.validate();
                })
            }
            return this.active.validate
        },
        warning_message_ro() {
            let ro = this.item.description.ro;
            if(ro) {
                if(ro.length < 200) {
                    return ["Your hotel is better. *min 200 caractere"]
                } else {
                    return []
                }
            } else {
                return []
            }
        },
        warning_message_en() {
            let en = this.item.description.en;
            if(en) {
                if(en.length < 200) {
                    return ["Your hotel is better. *min 200 characters"]
                } else {
                    return []
                }
            } else {
                return []
            }
        },
        status_hotel() {
            return [
                {
                    text: this.$t('hotel.detail.status.registered'),
                    value: "registered"
                }, {
                    text: this.$t('hotel.detail.status.accepted'),
                    value: "accepted"
                }, {
                    text: this.$t('hotel.detail.status.published'),
                    value: "published"
                }, {
                    text: this.$t('hotel.detail.status.suspended'),
                    value: "suspended"
                }, {
                    text: this.$t('hotel.detail.status.refused_by_us'),
                    value: "refused-by-us"
                }, {
                    text: this.$t('hotel.detail.status.refused_by_them'),
                    value: "refused-by-them"
                }
            ]
        },
        boolean_values() {
            return [
                {
                    text: this.$t('hotel.detail.boolean_values.yes'),
                    value: '1'
                }, {
                    text: this.$t('hotel.detail.boolean_values.no'),
                    value: '0'
                }
            ]
        },
        rules() {
            return {
                name: [v => !!v || this.$t('hotel.detail.form_rules.name')],
                type: [v => !!v || this.$t('hotel.detail.form_rules.type')],
                chain: [v => !!v || this.$t('hotel.detail.form_rules.chain')],
                capacity: [v => !!v || this.$t('hotel.detail.form_rules.capacity')],
                context: [v => !!v || this.$t('hotel.detail.form_rules.context')],
                clasification: [v => !!v || this.$t('hotel.detail.form_rules.clasification')],
                description: [v => !!v || this.$t('hotel.detail.form_rules.description')]
            }
        }

    },

    methods: {

        ...mapActions('alert', ['success', 'error']),

        checkChain() {
            switch (this.item.static.defaults.chain) {
            case null:
                this.chain = false;
                break;
            case undefined:
                this.chain = false;
                break;
            case '':
                this.chain = false;
                break;
            default:
                this.chain = true;
            }
        },
    },
};
</script>

<style lang="stylus">
.weekend-days .v-btn
    min-width: 55px
.description-warning
    &.v-input
        .v-text-field__details
            .v-messages
                .v-messages__message
                    color: orangered
//
</style>
